/**
 *  PauseScene
 *
 *  Created by Legman on 24/02/2017.
 *
 */

import Common           from "./Common";
import ScanlinesFilter  from "./ScanlinesFilter";

/**
 * @class
 */
export default class PauseScene extends p3.Scene {
    constructor() {
        super();

        /**
         * @member {signals.Signal}
         */
        this.signals.help = new signals.Signal();

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._panel = null;

        /**
         * @member {p3.MovieClip}
         * @private
         */
        this._steve = null;

        /**
         * @type {p3.MovieClip}
         * @private
         */
        this._steve2 = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._hand = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._homeButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._muteButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._helpButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._resumeButton = null;

        /**
         * @member {TimelineMax}
         * @private
         */
        this._animation = null;

        /**
         * @member {Audio}
         * @private
         */
        this._introSFX = null;
    }

    init() {
        super.init();

        const assets = Common.assets;

        const bg = new PIXI.Sprite(assets.getTexture("paused_overlay"));
        bg.width = p3.View.width;
        this.addChild(bg);

        this._panel = new PIXI.Sprite(assets.getTexture("paused_panel"));
        this._panel.x = p3.View.width * 0.5 + 6;
        this._panel.y = 60;
        this._panel.anchor.x = 0.5;
        this._panel.visible = false;
        this.addChild(this._panel);

        this._panel.stem = new PIXI.Sprite(assets.getTexture("paused_panel_stem"));
        this._panel.stem.anchor.x = 0.5;
        this._panel.addChild(this._panel.stem);

        this._panel.image = new PIXI.Sprite(assets.getTexture("instructions_screen"));
        this._panel.image.x = -14;
        this._panel.image.y = 862;
        this._panel.image.anchor = new PIXI.Point(0.5, 0.5);
        this._panel.image.visible = false;
        this._panel.addChild(this._panel.image);

        const sequence = new p3.MovieClipSequence();
        sequence.addTextures([assets.getTexture("instructions_monkey_fall"),
            assets.getTexture("instructions_monkey_land")]);

        this._steve = new p3.MovieClip(sequence);
        this._steve.y = -40;
        this._steve.anchor = new PIXI.Point(0.5, 0.5);
        this._steve.visible = false;
        this._panel.image.addChild(this._steve);

        this._steve2 = new p3.MovieClip(sequence);
        this._steve2.y = this._steve.y;
        this._steve2.anchor = new PIXI.Point(0.5, 0.5);
        this._steve2.visible = false;
        this._panel.image.addChild(this._steve2);

        this._hand = new PIXI.Sprite(assets.getTexture("tutorial_hand"));
        this._hand.x = 60;
        this._hand.y = 40;
        this._hand.anchor = new PIXI.Point(0.5, 0.5);
        this._panel.image.addChild(this._hand);

        /*
        this._titleLabel = new PIXI.extras.BitmapText("PAUSED...", {font: "100px Cloudy Bold Large", align: "center"});
        this._titleLabel.x = 20;
        this._titleLabel.y = 20;
        this._titleLabel.pivot.x = this._titleLabel.textWidth * 0.5;
        this._titleLabel.pivot.y = this._titleLabel.textHeight * 0.5;
        this._titleLabel.tint = 0xEF041F;
        this._panel.image.addChild(this._titleLabel);
        */

        const filter = new ScanlinesFilter(this._panel.image);
        this._panel.image.filters = [filter];

        let states = new p3.ButtonStates();
        states.normal = assets.getTexture("btn_small_off");
        states.icon = assets.getTexture("icon_home_off");

        this._homeButton = new p3.Button(states);
        this._homeButton.visible = false;
        this._homeButton.overSoundName = "sfx_btn_press_00";
        this._homeButton.clickSoundName = "sfx_btn_home_00";
        this._homeButton.signals.click.add(this.onHomeButtonClick, this);
        this.addChild(this._homeButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("btn_small_off");
        states.icon = assets.getTexture("icon_sound_off");
        states.iconAlt = assets.getTexture("icon_mute_off");

        this._muteButton = new p3.MuteButton(states);
        this._muteButton.visible = false;
        this._muteButton.overSoundName = "sfx_btn_press_00";
        this._muteButton.clickSoundName = "sfx_btn_home_00";
        this.addChild(this._muteButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("btn_small_off");
        states.icon = assets.getTexture("icon_help_off");

        this._helpButton = new p3.Button(states);
        this._helpButton.visible = false;
        this._helpButton.overSoundName = "sfx_btn_press_00";
        this._helpButton.clickSoundName = "sfx_btn_home_00";
        this._helpButton.signals.click.add(this.onHelpButtonClick, this);
        this.addChild(this._helpButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("btn_small_off");
        states.icon = assets.getTexture("icon_play_off");

        this._resumeButton = new p3.Button(states);
        this._resumeButton.visible = false;
        this._resumeButton.overSoundName = "sfx_btn_press_00";
        this._resumeButton.clickSoundName = "sfx_btn_home_00";
        this._resumeButton.signals.click.add(this.onResumeButtonClick, this);
        this.addChild(this._resumeButton);

        this._introSFX = Common.audio.playSound("sfx_game_play_cpu_intro_00");
    }

    destroy() {
        this._animation.kill();

        this._introSFX.stop();

        super.destroy();
    }

    appear() {
        super.appear();
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateIn(callback, scope) {
        // panel
        let to = this._panel.y;
        this._panel.y = -this._panel.height;
        TweenMax.to(this._panel, 0.4, {
            delay: 0.1,
            y: to,
            ease: Back.easeOut,
            easeParams: [0.8],
            onStart: function() {
                this._panel.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                // panel screen
                this._panel.image.scale.y = 0;
                TweenMax.to(this._panel.image.scale, 0.14, {
                    y: 1,
                    ease: Power2.easeInOut,
                    onStart: function() {
                        this._panel.image.visible = true;
                    },
                    onStartScope: this
                });
                this._panel.image.alpha = 0;
                TweenMax.to(this._panel.image, 0.1, {
                    alpha: 1,
                    ease: Power1.easeInOut
                });
            },
            onCompleteScope: this
        });

        // home button
        this._homeButton.scale = new PIXI.Point();
        TweenMax.to(this._homeButton.scale, 0.34, {
            delay: 0.2,
            x: 1.0,
            y: 1.0,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._homeButton.visible = true;
            },
            onStartScope: this
        });

        // mute button
        this._muteButton.scale = new PIXI.Point();
        TweenMax.to(this._muteButton.scale, 0.34, {
            delay: 0.2 + 0.06,
            x: 1.0,
            y: 1.0,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._muteButton.visible = true;
            },
            onStartScope: this
        });

        // help button
        /*
        this._helpButton.scale = new PIXI.Point();
        TweenMax.to(this._helpButton.scale, 0.34, {
            delay: 0.1 + 0.06 * 2,
            x: 1.0,
            y: 1.0,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._helpButton.visible = true;
            },
            onStartScope: this
        });
        */

        // resume button
        this._resumeButton.scale = new PIXI.Point();
        TweenMax.to(this._resumeButton.scale, 0.34, {
            delay: 0.2 + 0.06 * 2,
            x: 1.0,
            y: 1.0,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._resumeButton.visible = true;
            },
            onStartScope: this
        });

        this._animation = new TimelineMax({delay: 1, repeat: -1});

        // hand
        this._animation.append(TweenMax.to(this._hand.scale, 0.2, {
            delay: 0.2,
            x: 0.9,
            y: 0.9,
            ease: Back.easeOut,
            yoyo: true,
            repeat: 1,
            onStart: function() {
                this._hand.visible = true;
            },
            onStartScope: this
        }));
        this._animation.append(TweenMax.to(this._hand, 0.2, {
            delay: 0.2,
            alpha: 0,
            ease: Power1.easeInOut
        }));

        // steve
        this._steve.scale = new PIXI.Point();
        this._animation.append(TweenMax.to(this._steve.scale, 0.34, {
            x: 1,
            y: 1,
            ease: Back.easeOut,
            onStart: function() {
                this._steve.visible = true;
                this._steve.gotoAndStop(0);
            },
            onStartScope: this
        }));

        to = 124;
        let distance = to - this._steve.y;
        let speed = 460;
        this._animation.append(TweenMax.to(this._steve, distance / speed, {
            y: to,
            ease: Power1.easeIn,
            onComplete: function() {
                this._steve.gotoAndStop(1);
            },
            onCompleteScope: this
        }));

        // steve2
        this._steve2.scale = new PIXI.Point();
        this._animation.append(TweenMax.to(this._steve2.scale, 0.34, {
            delay: 0.8,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            onStart: function() {
                this._steve2.visible = true;
                this._steve2.gotoAndStop(0);
            },
            onStartScope: this
        }));

        to = 48;
        distance = to - this._steve2.y;
        speed = 460;
        this._animation.append(TweenMax.to(this._steve2, distance / speed, {
            y: to,
            ease: Power1.easeIn,
            onComplete: function() {
                this._steve2.gotoAndStop(1);
            },
            onCompleteScope: this
        }));

        this._animation.append(TweenMax.delayedCall(1, function() {}));
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateOut(callback, scope) {
    }

    resize() {
        this.y = (p3.View.height - Common.STAGE_HEIGHT) * 0.5;

        this._homeButton.x = 100;
        this._homeButton.y = (Common.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;

        this._muteButton.x = p3.View.width - 100;
        this._muteButton.y = (Common.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;

        this._resumeButton.x = p3.View.width - 100;
        this._resumeButton.y = (Common.STAGE_HEIGHT + p3.View.height) * 0.5 - 100;
    }

    update() {
        const filter = this._panel.image.filters[0];
        filter.time -= deltaTime * 4;
    }

    /**
     * @param {p3.Button} button
     */
    onHomeButtonClick(button) {
        this.signals.home.dispatch(this);
    }

    /**
     * @param {p3.Button} button
     */
    onHelpButtonClick(button) {
        this.signals.help.dispatch(this);
    }

    /**
     * @param {p3.Button} button
     */
    onResumeButtonClick(button) {
        this.signals.next.dispatch(this);
    }
}
